
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      window.locations ??= {}
;
      let d = window.wf.LocationDirectory;
      d.locations ??= {};
      d.checkedFeatures ??= [];
      d.selectedCounty ??= '';
      d.show_extra_tab ??= true;
      return d;
    },
    methods: {
      resetFilters() {
        this.checkedFeatures = [];
        this.selectedCounty = '';
      },
      hasEnhancedAtmFeature(location) {
        return this.enhancedAtmFeatures.some(r => location.features.includes(r));
      },
      updateMapLocations(tempFilteredLocations) {
        var tempWindowLocations = [];
        var i;
        if (tempFilteredLocations.length > 0) {
          for (i = 0; i < tempFilteredLocations.length; i++) {
            var tempLocation = tempFilteredLocations[i];
            tempWindowLocations.push(
              {
                name: tempLocation.name,
                address: tempLocation.address + '<br/>' + tempLocation.city + '<br/>' + tempLocation.state + ' ' + tempLocation.zip,
                googlemapsurl: tempLocation.googlemaps_url,
                lat: tempLocation.lat,
                long: tempLocation.long,
                url: tempLocation.url
              }
            )
          }
        }
        window.locations = tempWindowLocations;
      }
    },
    computed: {
      filteredLocations() {
        var tempFilteredLocations = this.locations;
        //return this.locations.filter;
        if (this.checkedFeatures.length > 0) {
          tempFilteredLocations = tempFilteredLocations.filter(el => this.checkedFeatures.some(r => el.features.includes(r)));
        }
        if (this.selectedCounty != '') {
          tempFilteredLocations = tempFilteredLocations.filter(el => el.county == this.selectedCounty);
        }
        // update locations for map whenever the filtered locations are recalculated
        this.updateMapLocations(tempFilteredLocations);

        return tempFilteredLocations;
      },
      enhancedAtmFeatures() {
        return this.features.filter(feature => feature.enhanced == 'True').map(i => i.feature_text);
      }
    }
  }

  window.addEventListener("load", (event) => {
    // sync tab display with location listing display
    document.addEventListener('shown.bs.collapse', checkLocationTabExternalContent);
    document.addEventListener('hidden.bs.collapse', checkLocationTabExternalContent);

    function checkLocationTabExternalContent() {
      if (document.getElementById("filter-tab") != null && document.getElementById('filter-tab-external-content') != null) {
        if (document.getElementById("filter-tab").offsetParent === null) {
          document.getElementById('filter-tab-external-content').classList.add("d-none");
        } else {
          document.getElementById('filter-tab-external-content').classList.remove("d-none");
        }
      }
    }

    // watch visible locations to update map
    const targetNode = document.getElementById("filter-tab-external-content");
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        eval("initMap()");
    };
    const observer = new MutationObserver(callback);
    if (targetNode != null) {
      observer.observe(targetNode, config);
    }
  });
